import React from "react";
import { shortId } from "./reviewAdapter";

/**
 * A reference as a person reads it: the name, then a small id chip — `Malévoz - Laurier` `…2794c2`.
 * A record that does not exist yet (the new institution before apply) gets « nouvel identifiant ».
 * `struck` = the link that goes away (before side); `strong` = the link it becomes (after side).
 */
export function RefChip({ refValue, struck = false, strong = false }) {
  if (!refValue) return null;
  const { id, name, isNew } = refValue;
  return (
    <span className={`sv-ref${struck ? " sv-ref--old" : ""}`}>
      <span className={`sv-ref-name${strong ? " sv-ref-name--new" : ""}`}>
        {name || "fiche sans nom"}
      </span>
      {isNew ? (
        <span className="sv-id sv-id--new">nouvel identifiant</span>
      ) : id ? (
        <span className="sv-id" title={`identifiant ${id}`}>
          {shortId(id)}
        </span>
      ) : null}
    </span>
  );
}
